import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              韩漫在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled || !isHome
                    ? 'bg-primary-50 text-primary-700'
                    : 'bg-background-50/20 text-background-50'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 5).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? scrolled || !isHome
                      ? 'bg-primary-50 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled || !isHome
                    ? 'bg-primary-50 text-primary-700'
                    : 'bg-background-50/20 text-background-50'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative flex items-center ${
              scrolled || !isHome ? 'bg-background-100' : 'bg-background-50/15'
            } rounded-full px-3 py-1.5`}>
              <i className={`ri-search-line text-sm mr-2 ${
                scrolled || !isHome ? 'text-foreground-500' : 'text-background-50/70'
              }`}></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`bg-transparent border-none outline-none text-sm w-36 ${
                  scrolled || !isHome
                    ? 'text-foreground-800 placeholder:text-foreground-400'
                    : 'text-background-50 placeholder:text-background-50/50'
                }`}
              />
            </div>
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 transition-colors cursor-pointer">
              <i className="ri-user-line text-background-50 text-sm"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">首页</Link>
            {categories.filter(c => c.slug !== 'all').map(cat => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">{cat.name}</Link>
            ))}
            <Link to="/about" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}